import ProgressBar from "react-bootstrap/ProgressBar";

export default function ApplicationProgressBar({ progressPercentage }) {
  return (
    <ProgressBar>
      <ProgressBar
        striped
        variant="success"
        label={`${progressPercentage}%`}
        now={progressPercentage}
        key={1}
      />
      <ProgressBar
        variant="warning"
        now={10}
        key={2}
        style={{ width: progressPercentage === 100 ? "0%" : "10%" }}
      />
    </ProgressBar>
  );
}
